import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface BrandState {
  selectedBrand: number
  setSelectedBrand: (brand: number) => void
}

export const useBrandStore = create<BrandState>()(
  persist(
    (set) => ({
      selectedBrand: 1,
      setSelectedBrand: (brand) => set({ selectedBrand: brand }),
    }),
    {
            name: "brand-storage", // unique name for localStorage key
    }
    )
);
